import type { Action } from "../actions.types";
import { isActionVisibleOnDashboard } from "./isActionVisibleOnDashboard";
import { isActionCompleted } from "./isActionCompleted";

/**
 * Get the count of incomplete actions that are visible on the dashboard.
 * Used for badge counts in navigation.
 *
 * @param actions - Array of user actions
 * @returns Number of incomplete, visible actions
 */
export function getIncompleteActionCount(actions: Action[]): number {
  if (!actions || actions.length === 0) return 0;

  return actions.filter(
    (action) => isActionVisibleOnDashboard(action) && !isActionCompleted(action)
  ).length;
}
